import { render } from "./myInput.vue?vue&type=template&id=2ab2b45f&scoped=true"
import script from "./myInput.vue?vue&type=script&lang=js"
export * from "./myInput.vue?vue&type=script&lang=js"

import "./myInput.vue?vue&type=style&index=0&id=2ab2b45f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab2b45f"]])

export default __exports__